module.exports = __webpack_public_path__ + "img/icon_views_2.397cd316.png";